import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/alumni.css";
import GraduateBatch1 from "../assets/images/graduateBatch1.jpeg";
import GraduateBatch2 from "../assets/images/graduateBatch2.jpeg";
import GraduateBatch3 from "../assets/images/graduateBatch3.jpeg";
import BestStudentBatch3 from "../assets/images/bestStudentBatch3.jpeg";
import StudentBatch4 from "../assets/images/studentBatch4.jpeg";

const alumniVideo =
  "https://www.dropbox.com/scl/fi/vff9lm3wrz8lwkhjqzsft/CEA-Alumni-Testimony.mp4?rlkey=8ixdj5mv2izjc9dnyzzh7z3wf&raw=1";

const alumniList = [
  {
    photo: GraduateBatch1,
    photoPosition: "center 25%",
    name: "Yoel Kenneth",
    title: "Graduate Batch 1",
    testimony:
      "Mengikuti CEA tidak hanya membantu saya memahami Firman Tuhan dengan lebih baik, tetapi juga menolong saya menerapkannya secara praktis dalam kehidupan sehari-hari, baik di keluarga, di tempat kerja, maupun dalam pelayanan.",
  },
  {
    photo: GraduateBatch2,
    name: "Luciana Crhistina",
    title: "Graduate Batch 2",
    testimony:
      "CEA mengubah cara saya membaca dan memahami Firman Tuhan. Saya belajar melihat pola dan prinsip Tuhan yang konsisten, sehingga iman saya semakin diteguhkan bahwa Tuhan tidak pernah berubah dan selalu dapat dipercaya. Pengalaman ini juga membentuk cara saya mendalami Firman, baik dalam saat teduh maupun saat menyusun kurikulum IFGF Kids, karena sekarang saya terbiasa menggali konteks Alkitab, melihat berbagai sudut pandang, dan menemukan kebenaran Firman yang lebih mendalam.",
  },
  {
    photo: GraduateBatch3,
    name: "Dorothy Cynthia",
    title: "Graduate Batch 3",
    testimony:
      "After taking CEA, I fell in love with the Bible and instead of reading it as quickly as possible, I now read the Bible more slowly. This helps me to understand God's words and patterns better. I also feel more confident in telling the gospel to my non believer friends. Having better knowledge about the Bible helps me to answer their doubts. But most importantly, I know the Bible has changed my life and I want my friends to read and believe in it too.",
  },
  {
    photo: BestStudentBatch3,
    name: "Ivana Yusti Kristanto",
    title: "Best Student Batch 3",
    testimony:
      "Through CEA, many of my values have been transformed, and I gained deeper understanding that has equipped my calling and ministry. I also discovered my calling, something I didn't realize before. It has truly been a life changing journey for me.",
  },
  {
    photo: StudentBatch4,
    name: "Temy Purnawan",
    title: "Graduate Batch 4",
    testimony: [
      "ngebul sekaliiiii CEA, tapi keren dan mantab..",
      "kita belajar tentang pola dan prinsip Tuhan dalam Alkitab, serta belajar menerapkan prinsip kebenaran dalam hidup keseharian..",
      "pembelajarannya sangat terbuka utk berdikusi, pengajarnya sangat kompeten, membuat kelas CEA sangat fun dan enjoy banget..",
    ],
  },
];

const Alumnipage = ({ setLocation }) => {
  const navigate = useNavigate();

  const address = useLocation();

  const handleNavigate = (goto) => {
    navigate(goto);
  };

  useEffect(() => {
    setLocation(address);
  }, []);
  return (
    <main className="d-flex justify-content-center align-items-center">
      <div className="custom-con1-alumni d-flex justify-content-center align-items-center flex-column">
        {/* <p className="custom-title-section1-alumni">Our Alumni</p> */}

        <div className="custom-con-vid-alumni">
          <video
            width="100%"
            height="100%"
            className="object-fit-cover"
            controls
            controlsList="nodownload"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
            preload="metadata"
          >
            <source src={alumniVideo} type="video/mp4" />
          </video>
        </div>

        {alumniList.map((alumni) => (
          <div className="row custom-row-alumni" key={alumni.name}>
            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4 d-flex justify-content-center align-items-center">
              <div className="custom-con-img-alumni">
                <img
                  className="adjust-photo-alumni object-fit-cover"
                  style={{ objectPosition: alumni.photoPosition || "center" }}
                  src={alumni.photo}
                  alt={`${alumni.name}.png`}
                />
              </div>
            </div>
            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 custom-col-right-alumni">
              <p className="custom-title-alumni">{alumni.name}</p>
              <p className="custom-minititle-alumni">({alumni.title})</p>
              <p className="custom-text-alumni">
                {Array.isArray(alumni.testimony)
                  ? (
                    <>
                      {'"'}
                      {alumni.testimony.map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          {i < alumni.testimony.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                      {'"'}
                    </>
                  )
                  : `"${alumni.testimony}"`}
              </p>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Alumnipage;
